import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { threeServices } from '../data/site';
import { MiniServiceVisual } from './visuals/MiniServiceVisual';
const visualVariant: Record<string, 'system' | 'yelp' | 'websites'> = {
  'The Viridia System': 'system',
  'Yelp Ads Management': 'yelp',
  Websites: 'websites'
};
type ThreeServicesCardsProps = {
  showVisual?: boolean;
};

/* Shared by the homepage's "Three ways we work with you" section and the
   /pricing three-column strip, both reading from data/site.ts's
   threeServices so the ladder never drifts between pages. showVisual is on
   for the homepage (each card carries a small living visual per Kevin's
   design bar) and off for /pricing (a plain, fast comparison). */
export function ThreeServicesCards({
  showVisual = false
}: ThreeServicesCardsProps) {
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-713" data-mp="2a4a69kh6qon">
      {threeServices.map((s, i) => <motion.article key={s.name} initial={{
      opacity: 0,
      y: 14
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.4,
      delay: i * 0.08
    }} className="flex flex-col rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d] p-7" data-id="element-714" data-mp="9g4pzzh45rcq" data-mpi={i}>
          {showVisual && <MiniServiceVisual variant={visualVariant[s.name]} data-id="element-715" data-mp="s5kpqkkz5fs3" />}

          <h3 className="mt-2 text-lg font-semibold text-white" data-id="element-716" data-mp="s3rip46g8tjk">{s.name}</h3>
          <p className="mt-2.5 text-sm leading-relaxed text-neutral-400" data-id="element-717" data-mp="o2xxwjoazuuw">{s.forWho}</p>

          <p className="mt-6 flex items-baseline gap-1.5 border-t border-[#1c1c1c] pt-6" data-id="element-718" data-mp="1240kqyn4h96v">
            <span className="text-2xl font-bold tracking-tight text-white" data-id="element-719" data-mp="x45pyk087zgj">{s.price}</span>
            {s.priceNote && <span className="text-sm text-neutral-500" data-id="element-720" data-mp="33uc1chj2cy39">{s.priceNote}</span>}
          </p>

          <Link to={s.to} className="group mt-6 inline-flex items-center gap-2 text-sm font-semibold text-emerald-500 hover:text-emerald-400" data-id="element-721" data-mp="2ywkazry2hk16">
            {s.cta}
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-722" data-mp="17rh30ycap535" />
          </Link>
        </motion.article>)}
    </div>;
}